export default function voicemailReducer(voicemail, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "exten":
      return { ...voicemail, exten: action.value ? Number(action.value).toString() : "" };
    case "playGreeting":
      return { ...voicemail, playGreeting: action.value, sound: action.value ? voicemail.sound : null };
    case "sound":
      if (action.value === null) {
        return { ...voicemail, sound: null };
      } else {
        return { ...voicemail, playGreeting: true, sound: action.list.find((sound) => sound.id === action.value) };
      }

    default:
      return { ...voicemail, [action.type]: action.value };
  }
}
